import { useInView } from "@/hooks/useInView";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  {
    q: "Jak długo trwa cały proces od zgłoszenia do budowy masztu?",
    a: "Uzyskanie wszystkich pozwoleń administracyjnych trwa zazwyczaj od 8 do 24 miesięcy. To proces wieloetapowy, wymagający decyzji środowiskowych, pozwoleń budowlanych i uzgodnień z operatorami — ale całość leży po naszej stronie. Ty nie musisz angażować się w żaden etap formalny.",
  },
  {
    q: "Kiedy zacznę otrzymywać czynsz dzierżawny?",
    a: "Czynsz naliczamy od roku, w którym rozpoczynają się prace budowlane — nie od daty podpisania umowy. Transparentnie informujemy o tej różnicy: po podpisaniu umowy do pierwszej wypłaty upływa czas oczekiwania na pozwolenia (8–24 miesięcy) i przygotowanie budowy.",
  },
  {
    q: "Jak wypłacany jest czynsz? Czy jest waloryzowany?",
    a: "Czynsz wypłacamy raz w roku, z góry — termin zapłaty to 28 lutego każdego roku. Trafia bezpośrednio na rachunek bankowy wskazany przez Ciebie w umowie. Stawka jest corocznie waloryzowana wg wskaźnika wzrostu cen towarów i usług konsumpcyjnych ogłaszanego przez Prezesa GUS — czyli rośnie razem z inflacją, więc realna wartość czynszu nie spada z biegiem lat. Jeśli pierwszy okres jest krótszy niż rok, czynsz naliczamy proporcjonalnie.",
  },
  {
    q: "Jak wygląda maszt? Czy nie zaszpeci krajobrazu mojej działki?",
    a: "Stosujemy kilka typów konstrukcji w zależności od lokalizacji: maszty kratownicowe o wysokości 30–50 m (klasyczne, najczęściej spotykane), słupy monopolowe (smukłe, jednolite, mniej rzucające się w oczy), a na dachach hal — niskie maszty antenowe (3–6 m). Konkretny typ proponujemy po audycie terenu i często konsultujemy z właścicielem. Maszty nie generują uciążliwego hałasu (poza krótkimi pracami serwisowymi raz na kilka miesięcy).",
  },
  {
    q: "Czy maszt telekomunikacyjny jest bezpieczny dla zdrowia i zwierząt?",
    a: "Tak. Stacje BTS spełniają rygorystyczne polskie i europejskie normy bezpieczeństwa w zakresie pól elektromagnetycznych (EMF). Poziomy promieniowania w pobliżu masztów są wielokrotnie niższe od dopuszczalnych progów ustalonych przez WHO i ICNIRP. Stacje podlegają regularnym kontrolom UKE.",
  },
  {
    q: "Co się stanie z umową, jeśli sprzedam lub odziedziczę działkę?",
    a: "Umowa dzierżawy \"chodzi z gruntem\" — jest automatycznie przenoszona na nowego właściciela nieruchomości. Maszt nie stanowi żadnej przeszkody dla sprzedaży ani dziedziczenia. Czynsz dzierżawny po prostu trafia do kolejnego właściciela.",
  },
  {
    q: "Czy posiadanie masztu wpłynie na wartość mojej działki?",
    a: "W większości przypadków nieruchomości z aktywną umową dzierżawy pod maszt BTS są wyceniane wyżej przez rzeczoznawców majątkowych. Stabilny, wieloletni dochód pasywny z umowy jest atrakcyjny dla inwestorów i potencjalnych kupujących.",
  },
  {
    q: "Czy mogę zrezygnować z umowy, jeśli zmienię zdanie?",
    a: "Umowa podstawowa zawierana jest na 10 lat, z możliwością przedłużenia aneksem do maksymalnie 29 lat (po uzyskaniu pozwolenia na budowę). To inwestycja infrastrukturalna — wycofanie się przed terminem wiąże się z konsekwencjami opisanymi w umowie. Każdą umowę przed podpisaniem możesz skonsultować z własnym prawnikiem. Przed rozpoczęciem prac budowlanych możliwa jest renegocjacja warunków; szczegóły zawsze ustalamy indywidualnie.",
  },
  {
    q: "Co jeśli sąsiedzi będą protestować przeciw budowie masztu?",
    a: "Procedura administracyjna przewiduje konsultacje społeczne i informowanie sąsiadów — całość prowadzimy my, łącznie z odpowiedziami na ewentualne sprzeciwy i reprezentacją w postępowaniu. Ty nie jesteś stroną w tych rozmowach. Mamy doświadczone biuro prawne, które przeprowadza klientów również przez trudniejsze przypadki.",
  },
  {
    q: "Co się stanie z masztem po zakończeniu umowy dzierżawy?",
    a: "Po wygaśnięciu umowy są dwie ścieżki: przedłużenie współpracy na kolejny okres (najczęstszy scenariusz — operatorzy chcą zachowywać sprawdzone lokalizacje) lub demontaż konstrukcji na nasz koszt z przywróceniem terenu do stanu pierwotnego. Koszt demontażu i rekultywacji jest zabezpieczony w umowie i nie obciąża właściciela gruntu.",
  },
  {
    q: "Co jeśli Telecom BTS zbankrutuje? Czy stracę czynsz?",
    a: "Umowa dzierżawy zawierana jest na warunkach gwarantujących ciągłość — w przypadku zmiany wykonawcy lub jego niewypłacalności prawa i obowiązki z umowy przechodzą na operatora telekomunikacyjnego, który faktycznie eksploatuje maszt. Operator (Orange / T-Mobile / Play / Plus lub inny) jest finalnym płatnikiem czynszu i to on gwarantuje kontynuację umowy. Dodatkowo wymagamy ubezpieczenia od odpowiedzialności cywilnej.",
  },
  {
    q: "Czy muszę samodzielnie uzyskiwać jakiekolwiek pozwolenia?",
    a: "Nie. Wszystkie decyzje administracyjne, projekty budowlane, ekspertyzy środowiskowe i formalna obsługa procesu leżą wyłącznie po naszej stronie. Ty podpisujesz wyłącznie umowę dzierżawy — i to wszystko.",
  },
  {
    q: "Jakie wymagania musi spełniać moja działka lub nieruchomość?",
    a: "Szukamy lokalizacji z odpowiednim dostępem (droga dojazdowa), w pobliżu miejscowości lub dróg krajowych/powiatowych. Powierzchnia konieczna do postawienia masztu jest stosunkowo niewielka — dla standardowego masztu kratownicowego o wysokości ok. 65 m na terenie wiejskim wystarczy działka około 12 × 12 m (ok. 150 m²). Interesują nas zarówno wolnostojące grunty rolne, jak i dachy hal produkcyjnych i magazynowych. Każda lokalizacja jest oceniana indywidualnie podczas bezpłatnego audytu.",
  },
];

export default function FAQ() {
  const [ref, inView] = useInView();

  return (
    <section id="faq" className="py-24 bg-white" data-testid="faq-section">
      <div className="max-w-4xl mx-auto px-6">
        <div
          ref={ref}
          className={`text-center mb-14 transition-all duration-700 ${
            inView ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
          }`}
        >
          <span className="text-emerald-600 text-sm font-semibold uppercase tracking-widest">
            Masz pytania?
          </span>
          <h2 className="text-4xl sm:text-5xl font-black text-slate-900 mt-2 tracking-tight">
            Najczęstsze pytania
          </h2>
          <p className="text-slate-500 text-lg mt-4 max-w-xl mx-auto">
            Zebraliśmy odpowiedzi na pytania, które słyszymy najczęściej od
            właścicieli gruntów i nieruchomości.
          </p>
        </div>

        <div
          className={`transition-all duration-700 ${
            inView ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
          }`}
          style={{ transitionDelay: "150ms" }}
        >
          <Accordion type="single" collapsible className="space-y-3">
            {faqs.map((faq, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                className="bg-slate-50 border border-slate-200 rounded-2xl px-6 overflow-hidden data-[state=open]:border-emerald-300 data-[state=open]:bg-emerald-50/30 transition-colors"
                data-testid={`faq-item-${i + 1}`}
              >
                <AccordionTrigger
                  className="font-display text-slate-900 font-semibold text-left py-5 hover:no-underline hover:text-emerald-700 text-sm sm:text-base"
                >
                  {faq.q}
                </AccordionTrigger>
                <AccordionContent className="text-slate-600 text-sm leading-relaxed pb-5">
                  {faq.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>

        <div
          className={`mt-10 text-center transition-all duration-700 ${
            inView ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
          }`}
          style={{ transitionDelay: "300ms" }}
        >
          <p className="text-slate-500 text-sm">
            Nie znalazłeś odpowiedzi na swoje pytanie?{" "}
            <button
              onClick={() =>
                document.getElementById("kontakt")?.scrollIntoView({ behavior: "smooth" })
              }
              className="text-emerald-600 font-semibold hover:underline"
            >
              Skontaktuj się z nami
            </button>
          </p>
        </div>
      </div>
    </section>
  );
}
